import {
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import TextArea from "antd/lib/input/TextArea";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { debounce } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
import TextAreaField from "../../common/htmlComponents/TextAreaField";
import { ReactComponent as About } from "../../image/About.svg";
import { ReactComponent as CircleIcon } from "../../image/CircleIcon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { ReactComponent as Email } from "../../image/Email.svg";
import { ReactComponent as Name } from "../../image/Name.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Vector } from "../../image/Vector.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

const RequestedDemoModel = ({
  handleRefresh,
  requesteddemoId,
  setStateList,
  stateList,
  setRequestedDemoId,
  handleCancel,
  form,
  setReload,
  reload,
  modalKey,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  dayjs.extend(customParseFormat);

  const formRefFollowUp = useRef();

  // state initialisation
  const initialState = {
    name: "",
    company: "",
    phone_number: "91",
    email: "",
    no_of_buyer: "",
    demo_date: null,
    request_date: dayjs().format("DD-MM-YYYY HH:mm"),
    about_company: "",
    remark: "",
    demo_type: "Online",
  };
  const initialDocument = {
    request_demo: requesteddemoId,
    follow_up_date: null,
    follow_up_note: null,
  };
  const { Panel } = Collapse;
  const [state, setState] = useState(initialState);
  const [documentState, setDocumentState] = useState(initialDocument);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingAdd, setBtnLoadingAdd] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [companyDocumentList, setCompanyDocumentList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [addedCompanyId, setAddedCompanyId] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [companyDocumentId, setCompanyDocumentId] = useState(null);
  const [apiloading, setapiLoading] = useState(false);
  const [apiloadingFollow, setapiloadingFollow] = useState(false);
  const [btnDisplay, setBtnDisplay] = useState("Add");

  const [stateDocumentTable, setStateDocumentTable] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const { Search } = Input;
  const colors = ["#094E8F"];

  // Fetch Company Documenet
  useEffect(() => {
    const getCompanyDocument = async () => {
      setapiloadingFollow(true);
      try {
        const apiResponse = await getRequest(
          `request-for-demo-follow-up/${companyDocumentId}`
        );
        if (apiResponse.data.success) {
          const follow_up_date = apiResponse.data.data.follow_up_date
            ? moment(apiResponse.data.data.follow_up_date, "DD-MM-YYYY HH:mm")
            : null;

          setDocumentState({
            ...apiResponse.data.data,
            follow_up_date: apiResponse.data.data.follow_up_date
              ? moment(
                  apiResponse.data.data.follow_up_date,
                  "DD-MM-YYYY HH:mm"
                ).format("DD-MM-YYYY HH:mm")
              : null,
          });

          formRefFollowUp.current.setFieldsValue({
            ...apiResponse.data.data,
            follow_up_date: apiResponse.data.data.follow_up_date
              ? moment(follow_up_date, "DD-MMMM-YYYY HH:mm")
              : null,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloadingFollow(false);
      } catch (error) {
        setapiloadingFollow(false);
      }
    };
    if (companyDocumentId !== null) {
      getCompanyDocument();
    }
  }, [companyDocumentId, t]);

  //Fetch Company Document List
  useEffect(() => {
    const getCompanyDocumentList = async () => {
      setLoading(true);
      try {
        let apiResponse = await getRequest(
          `request-for-demo-follow-up/?request_demo=${addedCompanyId}`,
          stateDocumentTable
        );
        if (apiResponse.data.results.success === true) {
          setCompanyDocumentList(apiResponse.data.results.data);

          settotalCount(apiResponse.data.count);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    if (addedCompanyId !== null) {
      getCompanyDocumentList();
    }
  }, [stateDocumentTable, reload, t, refreshGrid, addedCompanyId]);

  // Fetch Request Demo By Id
  useEffect(() => {
    const requesteddemoGetById = async () => {
      try {
        setapiLoading(true);
        const apiResponse = await getRequest(
          `request-demo/${requesteddemoId}/`
        );
        if (apiResponse.data.success) {
          setAddedCompanyId(apiResponse.data.data.id);
          const demoDate = apiResponse.data.data.demo_date
            ? moment(apiResponse.data.data.demo_date, "DD-MM-YYYY HH:mm")
            : null;
          const requestDate = apiResponse.data.data.request_date
            ? moment(apiResponse.data.data.request_date, "DD-MM-YYYY HH:mm")
            : null;
          setState({
            ...apiResponse.data.data,
            phone_number: apiResponse.data.data.phone_number,
            demo_type: apiResponse.data.data.demo_type,
            demo_date: apiResponse.data.data.demo_date
              ? moment(
                  apiResponse.data.data.demo_date,
                  "DD-MM-YYYY HH:mm"
                ).format("DD-MM-YYYY HH:mm")
              : null,
            request_date: apiResponse.data.data.request_date
              ? moment(
                  apiResponse.data.data.request_date,
                  "DD-MM-YYYY HH:mm"
                ).format("DD-MM-YYYY HH:mm")
              : null,
          });
          setFormSubmitted(true);
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            phone_number: apiResponse.data.data.phone_number,
            demo_date: demoDate ? moment(demoDate, "DD-MMMM-YYYY HH:mm") : null,
            request_date: requestDate
              ? moment(requestDate, "DD-MMMM-YYYY HH:mm")
              : null,
          });
          setapiLoading(false);
          // SuccessNotificationMsg("Demo request updated")
        }
      } catch (error) {
        setapiLoading(false);
      }
    };
    if (requesteddemoId !== null) {
      requesteddemoGetById();
    }
  }, [requesteddemoId, modalKey]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Handle Refresh Grid
  const handleRefreshGrid = () => {
    setRefreshGrid((refreshGrid) => !refreshGrid);
  };

  const columns = [
    {
      title: "Follow Up Date",
      dataIndex: "follow_up_date",
      key: "follow_up_date",
      sorter: true,
    },
    {
      title: "Note",
      dataIndex: "follow_up_note",
      key: "follow_up_note",
      sorter: true,
      width: 150,
      render: (dataIndex) => (
        <Tooltip
          color={colors}
          placement="left"
          title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        >
          <div
            style={{
              width: "150px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record) => (
        <Space>
          <Editicon onClick={() => handleEditIconClick(record.id)} />
        </Space>
      ),
    },
  ];
  const disabledDate = (current) => {
    // Can not select days before today
    return current && current < dayjs().startOf("day");
  };

  // Handle Input Change
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const handleNoteChange = (name, e) => {
    setDocumentState({ ...documentState, [name]: e.target.value });
  };

  // Handle Option change
  const handleOptionChange = (fieldName, value) => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: value, // Use boolean directly
    }));
  };
  const handleDatepickerChangeFollowUp = (date, dateString, fieldName) => {
    const formattedDateString = dateString
      ? moment(dateString, "DD MMMM YYYY HH:mm").format("DD-MM-YYYY HH:mm")
      : null;

    setDocumentState({
      ...documentState,
      [fieldName]: formattedDateString ? formattedDateString : null,
    });
  };
  const handleDatepickerChange = (date, dateString, fieldName) => {
    const formattedDateString = dateString
      ? moment(dateString, "DD MMMM YYYY HH:mm").format("DD-MM-YYYY HH:mm") 
      : null;

    setState({
      ...state,
      [fieldName]: formattedDateString ? formattedDateString : null,
    });
  };

  const disabledDateTime = (current) => {
    const now = dayjs();
  
    // Only disable time if selected date is today
    if (current && current.isSame(now, 'day')) {
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter(
            (hour) => hour < now.hour()
          ),
        disabledMinutes: (selectedHour) => {
          if (selectedHour === now.hour()) {
            return Array.from({ length: 60 }, (_, i) => i).filter(
              (minute) => minute < now.minute()
            );
          }
          return [];
        },
      };
    }
  
    // For future dates, allow all time
    return {};
  };
  

  const phoneValidLength = state.phone_number;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error("Please enter valid phone."));
    }
    return Promise.resolve();
  };

  // Back To List
  const backToList = () => {
    setState(initialState);
    setFormSubmitted(false);
    setAddedCompanyId(null);
    setCompanyDocumentList(null);
    setButtonDisabled(false);
    setBtnDisplay("Add");
    formRef?.current?.setFieldsValue(initialState);
    setDocumentState(initialState);
    if (formSubmitted) {
      formRefFollowUp?.current?.setFieldsValue(initialDocument);
    }
    handleCancel();
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setStateDocumentTable({
      ...stateDocumentTable,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "follow_up_date" && sortOrder === "ascend") {
      sortingEnumKey = "follow_up_date";
    }
    if (sortField === "follow_up_date" && sortOrder === "descend") {
      sortingEnumKey = "-follow_up_date";
    }
    if (sortField === "follow_up_note" && sortOrder === "ascend") {
      sortingEnumKey = "follow_up_note";
    }
    if (sortField === "follow_up_note" && sortOrder === "descend") {
      sortingEnumKey = "-follow_up_note";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearchTable);
  };

  const onSearchTable = (value) => {
    setStateDocumentTable({
      ...stateDocumentTable,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const handleEditIconClick = (id) => {
    setCompanyDocumentId(id);
    setBtnDisplay("Edit");
  };

  // Fetch Form Submit
  const handleSubmit = async () => {
    console.log('statexs', state);
    
    const formattedState = {
      ...state,
      demo_date: dayjs(state.demo_date, "DD-MM-YYYY HH:mm").format("DD-MM-YY HH:mm"),
      request_date: dayjs(state.request_date, "DD-MM-YYYY HH:mm").format("DD-MM-YY HH:mm"),
    };
    
    console.log('formattedState', formattedState);
    
    try {
      setBtnLoading(true);
      let response;
      if (requesteddemoId === null) {
        response = await postRequest("request-demo/", formattedState);
      } else {
        response = await patchRequest(
          `request-demo/${requesteddemoId}/`,
          formattedState
        );
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          requesteddemoId === null
            ? t("Demo request added successfully")
            : t("Demo request updated successfully")
        );
        handleCancel()
        setFormSubmitted(true);
        if (requesteddemoId === null) {
          setButtonDisabled(true);
          handleRefresh();
        }
        setAddedCompanyId(response.data.data.id);
        setBtnLoading(false);
        setReload((reload) => !reload);
      }
    } catch (error) {
      ErrorNotificationMsg(t("error_in_updating_demo_list"));
      setBtnLoading(false);
    }
  };

  // Handle Company Submit
  const handleCompanySubmit = async () => {
    console.log("documentState", documentState);
    
    // const payload = {
    //   request_demo: addedCompanyId,
    //   follow_up_date: documentState.follow_up_date,
    //   follow_up_note: documentState.follow_up_note,
    // };

    const formattedPayload = {
      request_demo: addedCompanyId,
      follow_up_date: moment(documentState.follow_up_date, "DD-MM-YYYY HH:mm").format("DD-MM-YY HH:mm"),
      follow_up_note: documentState.follow_up_note,
    };

    try {
      let apiResponse;
      setBtnLoadingAdd(true);
      if (companyDocumentId === null) {
        apiResponse = await postRequest("request-for-demo-follow-up/", formattedPayload);
      } else {
        apiResponse = await patchRequest(
          `request-for-demo-follow-up/${companyDocumentId}/`,
          formattedPayload
        );
      }

      if (apiResponse.data.success === true) {
        handleRefreshGrid();
        SuccessNotificationMsg(
          companyDocumentId === null
            ? t("follow_up_added_successfully")
            : t("follow_up_updated_successfully")
        );
        setBtnDisplay("Add");
        setCompanyDocumentId(null);
        setDocumentState({ follow_up_date: null, follow_up_note: null });

        formRefFollowUp.current.setFieldsValue({
          follow_up_date: "",
          follow_up_note: "",
        });
      }
      setBtnLoadingAdd(false);
    } catch (error) {
      setBtnLoadingAdd(false);
    }
  };
  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          className="ModalForm"
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
        >
          <Row gutter={[15]}>
            <Col md={12} className="TextFeild">
              <InputField
                name="name"
                label={t("pl_requested_name")}
                placeholder={t("pl_enter_your_name")}
                prefix={<Name />}
                pattern={"^[a-zA-Z ]+$"}
                rules={t("val_name")}
                handleInputChange={handleInputChange}
                max={30}
              />
            </Col>
            <Col md={12} className="TextFeild">
              <InputField
                name="company"
                label={t("company_name_requesteddemo")}
                placeholder={t("pl_enter_your_company_name")}
                prefix={<Vector />}
                pattern={"^[a-zA-Z ]+$"}
                rules={t("val_companyName")}
                handleInputChange={handleInputChange}
                max={30}
              />
            </Col>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="phone_number"
                label={t("label_phoneNumber")}
                rules={[
                  {
                    required: true,
                    validator: validatePhoneNumber,
                    message: <Trans> {t("val_phone")}</Trans>,
                  },
                ]}
              >
                <PhoneInput
                  country={"in"}
                  value={
                    state.phone_number !== null ? state.phone_number : null
                  }
                  onChange={(phone) =>
                    setState({ ...state, phone_number: phone ? phone : null })
                  }
                />
              </Form.Item>
            </Col>
            <Col md={12} className="TextFeild">
              <EmailField
                name="email"
                label={t("pl_e_mail")}
                placeholder={t("pl_enter_your_email")}
                prefix={<Email />}
                rules={t("val_email")}
                handleInputChange={handleInputChange}
              />
            </Col>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="no_of_buyer"
                label={
                  <span>
                    {t("pl_num_of_buyers")}
                    <Tooltip
                      color={colors}
                      style={{ color: "#fff" }}
                      placement="right"
                      title="Cement Category"
                    >
                      <CircleIcon style={{ marginLeft: "6px" }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_number_of_buyers")}</Trans>,
                  },
                ]}
              >
                <Input
                  className="numberrange"
                  type="number"
                  placeholder={t("pl_enter_number_of_buyers")}
                  onChange={(value) =>
                    setState({
                      ...state,
                      no_of_buyer: Number(value.target.value),
                    })
                  }
                />
              </Form.Item>
            </Col>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="demo_date"
                label={t("pl_demo_date_time")}
                rules={[
                  {
                    required: true,
                    message: <Trans>Please Select Demo Date</Trans>,
                  },
                ]}
              >
                <DatePicker
                  showTime={true}
                  showNow={false}
                  format="DD MMMM YYYY  HH:mm"
                  disabledDate={disabledDate}
                  disabledTime={disabledDateTime}
                  onChange={(date, dateString) =>
                    handleDatepickerChange(date, dateString, "demo_date")
                  }
                  value={
                    state?.demo_date
                      ? moment(state?.demo_date, "DD-MM-YYYY HH:mm")
                      : null
                  }
                />
              </Form.Item>
            </Col>

            <Col md={12} className="Textarea">
              <TextAreaField
                name="about_company"
                label={t("pl_about_company_requesteddemo")}
                placeholder={t("pl_enter_about_your_company_requesteddemo")}
                prefix={<About />}
                handleInputChange={handleInputChange}
                rules={"Please add about company"}
              />
            </Col>
            <Col md={12} className="Textarea">
              <TextAreaField
                name="remark"
                label={t("pl_remark")}
                placeholder={t("place_remark")}
                prefix={<About />}
                handleInputChange={handleInputChange}
                // rules={t("Please add remark")}
              />
            </Col>
          </Row>
          <Col md={12} className="TextFeild">
            <Form.Item
              className="radioitem radio2"
              name="demo_type"
              label="Mode Of Demo"
              initialValue={"Online"}
              rules={[
                {
                  required: true,
                  message: "Select Demo Type",
                },
              ]}
            >
              <Radio.Group
                className="customrgroup"
                onChange={(e) =>
                  handleOptionChange("demo_type", e.target.value)
                }
                value={state?.demo_type}
                defaultValue="Online"
              >
                <Radio value="Online">Online</Radio>
                <Radio value="Offline">Offline</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <div
            className="ModalPopupFooter"
            style={{
              marginBottom: "16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />
            {buttonDisabled ? (
              ""
            ) : (
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                label={t("save")}
                loading={btnLoading}
              />
            )}
          </div>
        </Form>
      </Spin>
      {/* <>
        {formSubmitted && (
          <Collapse defaultActiveKey={["1"]}>
            <Panel header="Follow Up" key="1">
              <>
                <Spin spinning={apiloadingFollow}>
                  <Form
                    onFinish={handleCompanySubmit}
                    autoComplete="off"
                    ref={formRefFollowUp}
                  >
                    <Row gutter={[15]}>
                      <Col xs={24} md={12} className="TextFeild gutter-row">
                        <Form.Item
                          name="follow_up_date"
                          label={t("pl_requested_demo_date_time4")}
                          rules={[
                            {
                              required: false,
                              message: <Trans>Please Select Demo Date</Trans>,
                            },
                          ]}
                        >
                          <Tooltip
                            color={colors}
                            style={{ color: "#fff" }}
                            placement="top"
                            title="Demo Request Date & Time"
                          >
                            <DatePicker
                              showTime={true}
                              showNow={false}
                              disabledDate={disabledDate}
                              disabledTime={disabledDateTime}
                              // format="YYYY-MM-DD hh:mm"
                              format="DD MMMM YYYY HH:mm"
                              value={
                                documentState?.follow_up_date
                                  ? moment(
                                      documentState?.follow_up_date,
                                      "DD-MM-YYYY HH:mm"
                                    )
                                  : null
                              }
                              onChange={(date, dateString) =>
                                handleDatepickerChangeFollowUp(
                                  date,
                                  dateString,
                                  "follow_up_date"
                                )
                              }
                            />
                          </Tooltip>
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12} className="TextFeild gutter-row">
                        <Form.Item
                          name={`follow_up_note`}
                          label={t("pl_note")}
                          rules={[
                            {
                              min: 3,
                              message: <Trans>{t("minlength_msg")}</Trans>,
                            },
                            {
                              max: 50,
                              message: (
                                <Trans>{t("maxlength_designation1")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <TextArea
                            placeholder={t("place_note")}
                            value={documentState?.note}
                            onChange={(value) =>
                              handleNoteChange("follow_up_note", value)
                            }
                            autoSize={{ minRows: 1.5, maxRows: 2 }} // This will
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "10px",
                          }}
                        >
                          <ButtonField
                            type="primary"
                            className="SaveGradiantBtn "
                            htmlType="Submit"
                            label={t(btnDisplay)}
                            loading={btnLoadingAdd}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Spin>
                <>
                  <Row className="pagenamewrap">
                    <Col xs={24}>
                      <div className="searchwrp demoreq">
                        <Space direction="vertical">
                          <Search
                            prefix={
                              <img
                                src={SearchIcon}
                                alt="SearchIcon"
                                className="SearchIcon"
                                width={22}
                              />
                            }
                            placeholder={t("pl_search_list")}
                            onChange={searchCallbackDelayed}
                            style={{
                              width: 250,
                            }}
                          />
                        </Space>
                      </div>
                    </Col>
                  </Row>

                  <Table
                    columns={columns}
                    rowKey={(record) => record.id}
                    dataSource={companyDocumentList}
                    loading={loading}
                    pagination={{
                      defaultCurrent: state.page,
                      defaultPageSize: state.pagesize,
                      total: totalCount,
                      showTotal: (total) => `Total ${total} items`,
                      showSizeChanger: true,
                      locale: {
                        items_per_page: "Items / Page", // Text for the size changer
                      },
                    }}
                    onChange={handleTableChange}
                  />
                </>
              </>
            </Panel>
          </Collapse>
        )}
      </> */}
    </>
  );
};
RequestedDemoModel.propTypes = {
  requesteddemoId: PropTypes.number,
  setRequestedDemoId: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  setStateList: PropTypes.func,
  stateList: PropTypes.object,

  setReload: PropTypes.func,
  reload: PropTypes.bool,
  form: PropTypes.object,
  handleRefresh: PropTypes.func,
  modalKey: PropTypes.bool,
};

export default RequestedDemoModel;
